<div class="dialog-container">
  <h1 mat-dialog-title>Component Ownership</h1>

  <mat-dialog-content>
    <form [formGroup]="formGroup" class="dialog-form">
      <div class="row gx-3 gy-3">
        <div *ngIf="!isBulkUpdate" class="col-xl-6 col-lg-12 col-md-12">
          <mat-form-field floatLabel="always">
            <mat-label>{{ componentOwnershipLabels.COMPONENT }}</mat-label>
            <input type="text" matInput [formControlName]="componentOwnershipFields.COMPONENT" required />
            <mat-error fxLayout="column" *ngIf="formGroup.get(componentOwnershipFields.COMPONENT).errors">
              <span
                *ngIf="
                  formGroup.get(componentOwnershipFields.COMPONENT).hasError('required') &&
                  formGroup.get(componentOwnershipFields.COMPONENT).touched
                "
              >
                This field is required
              </span>
            </mat-error>
          </mat-form-field>
        </div>
        <div *ngIf="!isBulkUpdate" class="col-xl-3 col-lg-6 col-md-12">
          <mat-form-field floatLabel="always">
            <mat-label>{{ componentOwnershipLabels.CODE }}</mat-label>
            <input
              type="text"
              style="text-transform: uppercase"
              matInput
              [formControlName]="componentOwnershipFields.CODE"
              required
            />
            <mat-error fxLayout="column" *ngIf="formGroup.get(componentOwnershipFields.CODE).errors">
              <span
                *ngIf="
                  formGroup.get(componentOwnershipFields.CODE).hasError('required') &&
                  formGroup.get(componentOwnershipFields.CODE).touched
                "
              >
                This field is required
              </span>
              <span
                *ngIf="
                  formGroup.get(componentOwnershipFields.CODE).hasError('maxlength') &&
                  formGroup.get(componentOwnershipFields.CODE).touched
                "
              >
                Max length is 3 characters
              </span>
            </mat-error>
          </mat-form-field>
        </div>
        <div *ngIf="!isBulkUpdate" class="col-xl-3 col-lg-6 col-md-12">
          <mat-form-field floatLabel="always">
            <mat-label>{{ componentOwnershipLabels.VERSION }}</mat-label>
            <input type="text" matInput [formControlName]="componentOwnershipFields.VERSION" required />
            <mat-error fxLayout="column" *ngIf="formGroup.get(componentOwnershipFields.VERSION).errors">
              <span
                *ngIf="
                  formGroup.get(componentOwnershipFields.VERSION).hasError('required') &&
                  formGroup.get(componentOwnershipFields.VERSION).touched
                "
              >
                This field is required
              </span>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-xl-4 col-lg-6 col-md-12">
          <mat-form-field floatLabel="always">
            <mat-label>{{ componentOwnershipLabels.ON_PREM_GKE }}</mat-label>
            <mat-select [formControlName]="componentOwnershipFields.ON_PREM_GKE">
              <mat-option *ngFor="let option of apiOnPremGkeCd" [value]="option">
                {{ option }}
              </mat-option>
            </mat-select>
            <mat-error fxLayout="column" *ngIf="formGroup.get(componentOwnershipFields.ON_PREM_GKE).errors">
              <span
                *ngIf="
                  formGroup.get(componentOwnershipFields.ON_PREM_GKE).hasError('required') &&
                  formGroup.get(componentOwnershipFields.ON_PREM_GKE).touched
                "
              >
                This field is required
              </span>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-xl-4 col-lg-6 col-md-12">
          <mat-form-field floatLabel="always">
            <mat-label>{{ componentOwnershipLabels.EMPLOYEE_CUSTOMER }}</mat-label>
            <mat-select [formControlName]="componentOwnershipFields.EMPLOYEE_CUSTOMER">
              <mat-option *ngFor="let option of apiEmployeeCustomerFacingCd" [value]="option">
                {{ option }}
              </mat-option>
            </mat-select>
            <mat-error fxLayout="column" *ngIf="formGroup.get(componentOwnershipFields.EMPLOYEE_CUSTOMER).errors">
              <span
                *ngIf="
                  formGroup.get(componentOwnershipFields.EMPLOYEE_CUSTOMER).hasError('required') &&
                  formGroup.get(componentOwnershipFields.EMPLOYEE_CUSTOMER).touched
                "
              >
                This field is required
              </span>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-xl-4 col-lg-6 col-md-12">
          <mat-form-field floatLabel="always">
            <mat-label>{{ componentOwnershipLabels.COMPONENT_TYPE }}</mat-label>
            <mat-select [formControlName]="componentOwnershipFields.COMPONENT_TYPE">
              <mat-option *ngFor="let option of apiComponentTypeCd" [value]="option">
                {{ option }}
              </mat-option>
            </mat-select>
            <mat-error fxLayout="column" *ngIf="formGroup.get(componentOwnershipFields.COMPONENT_TYPE).errors">
              <span
                *ngIf="
                  formGroup.get(componentOwnershipFields.COMPONENT_TYPE).hasError('required') &&
                  formGroup.get(componentOwnershipFields.COMPONENT_TYPE).touched
                "
              >
                This field is required
              </span>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-xl-6 col-lg-12 col-md-12 pb-24">
          <xpo-prime-multiselect
            [formGroup]="formGroup"
            [options]="techList"
            [selectedObjectsToDisplay]="selectedTechList"
            [name]="componentOwnershipLabels.TECHNOLOGY_LIST"
            [formControlName]="componentOwnershipFields.TECHNOLOGY_LIST"
            [required]="!isBulkUpdate"
          >
          </xpo-prime-multiselect>
        </div>
        <div class="col-xl-6 col-lg-12 col-md-12">
          <mat-form-field floatLabel="always">
            <mat-label>{{ componentOwnershipLabels.TEAM }}</mat-label>
            <input type="text" matInput [formControlName]="componentOwnershipFields.TEAM" />
            <mat-error fxLayout="column" *ngIf="formGroup.get(componentOwnershipFields.TEAM).errors">
              <span
                *ngIf="
                  formGroup.get(componentOwnershipFields.TEAM).hasError('required') &&
                  formGroup.get(componentOwnershipFields.TEAM).touched
                "
              >
                This field is required
              </span>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-xl-4 col-lg-6 col-md-12">
          <mat-form-field floatLabel="always">
            <mat-label>{{ componentOwnershipLabels.COMPONENT_LEVEL }}</mat-label>
            <input type="number" matInput [formControlName]="componentOwnershipFields.COMPONENT_LEVEL" />
            <mat-error fxLayout="column" *ngIf="formGroup.get(componentOwnershipFields.COMPONENT_LEVEL).errors">
              <span
                *ngIf="
                  formGroup.get(componentOwnershipFields.COMPONENT_LEVEL).hasError('required') &&
                  formGroup.get(componentOwnershipFields.COMPONENT_LEVEL).touched
                "
              >
                This field is required
              </span>
              <span
                *ngIf="
                  formGroup.get(componentOwnershipFields.COMPONENT_LEVEL).hasError('max') &&
                  formGroup.get(componentOwnershipFields.COMPONENT_LEVEL).touched
                "
              >
                Max value is 99
              </span>
              <span
                *ngIf="
                  formGroup.get(componentOwnershipFields.COMPONENT_LEVEL).hasError('min') &&
                  formGroup.get(componentOwnershipFields.COMPONENT_LEVEL).touched
                "
              >
                Min value is 0
              </span>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-xl-4 col-lg-6 col-md-12">
          <mat-form-field floatLabel="always">
            <mat-label>{{ componentOwnershipLabels.STATUS_CD }}</mat-label>
            <mat-select [formControlName]="componentOwnershipFields.STATUS_CD">
              <mat-option *ngFor="let option of apiComponentStatusCd" [value]="option">
                {{ option }}
              </mat-option>
            </mat-select>
            <mat-error fxLayout="column" *ngIf="formGroup.get(componentOwnershipFields.STATUS_CD).errors">
              <span
                *ngIf="
                  formGroup.get(componentOwnershipFields.STATUS_CD).hasError('required') &&
                  formGroup.get(componentOwnershipFields.STATUS_CD).touched
                "
              >
                This field is required
              </span>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-xl-4 col-lg-6 col-md-12">
          <mat-form-field floatLabel="always">
            <mat-label>{{ componentOwnershipLabels.SUPER_COMPONENT_CD }}</mat-label>
            <mat-select [formControlName]="componentOwnershipFields.SUPER_COMPONENT_CD">
              <mat-option *ngFor="let option of apiSuperComponentCd" [value]="option">
                {{ option }}
              </mat-option>
            </mat-select>
            <mat-error fxLayout="column" *ngIf="formGroup.get(componentOwnershipFields.SUPER_COMPONENT_CD).errors">
              <span
                *ngIf="
                  formGroup.get(componentOwnershipFields.SUPER_COMPONENT_CD).hasError('required') &&
                  formGroup.get(componentOwnershipFields.SUPER_COMPONENT_CD).touched
                "
              >
                This field is required
              </span>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-xl-6 col-lg-12 col-md-12 pb-24">
          <xpo-prime-autocomplete
            [source]="source"
            [selectedObjectToDisplay]="selectedAutocompleteValues[componentOwnershipFields.LEADERSHIP_ID]"
            [formGroup]="formGroup"
            [formControlName]="componentOwnershipFields.LEADERSHIP_ID"
            [name]="componentOwnershipLabels.LEADERSHIP_NAME"
            [required]="false"
            [readonly]="true"
            [showClear]="true"
            [minLength]="2"
            [forceSelection]="true"
            placeholder="Search by lastName"
          >
          </xpo-prime-autocomplete>
        </div>
        <div class="col-xl-6 col-lg-12 col-md-12 pb-24">
          <xpo-prime-autocomplete
            [source]="source"
            [selectedObjectToDisplay]="selectedAutocompleteValues[componentOwnershipFields.PRODUCT_OWNER_ID]"
            [formGroup]="formGroup"
            [formControlName]="componentOwnershipFields.PRODUCT_OWNER_ID"
            [name]="componentOwnershipLabels.PRODUCT_OWNER_NAME"
            [required]="false"
            [readonly]="true"
            [showClear]="true"
            [minLength]="2"
            [forceSelection]="true"
            placeholder="Search by lastName"
          >
          </xpo-prime-autocomplete>
        </div>
        <div class="col-xl-6 col-lg-12 col-md-12 pb-24">
          <xpo-prime-autocomplete
            [source]="source"
            [selectedObjectToDisplay]="selectedAutocompleteValues[componentOwnershipFields.TECH_LEAD_ID]"
            [formGroup]="formGroup"
            [formControlName]="componentOwnershipFields.TECH_LEAD_ID"
            [name]="componentOwnershipLabels.TECH_LEAD_NAME"
            [required]="false"
            [readonly]="true"
            [showClear]="true"
            [minLength]="2"
            [forceSelection]="true"
            placeholder="Search by lastName"
          >
          </xpo-prime-autocomplete>
        </div>
        <div class="col-xl-6 col-lg-12 col-md-12 pb-24">
          <xpo-prime-autocomplete
            [source]="source"
            [selectedObjectToDisplay]="selectedAutocompleteValues[componentOwnershipFields.ARCHITECT_ID]"
            [formGroup]="formGroup"
            [formControlName]="componentOwnershipFields.ARCHITECT_ID"
            [name]="componentOwnershipLabels.ARCHITECT_NAME"
            [required]="false"
            [readonly]="true"
            [showClear]="true"
            [minLength]="2"
            [forceSelection]="true"
            placeholder="Search by lastName"
          >
          </xpo-prime-autocomplete>
        </div>
        <div class="col-xl-6 col-lg-12 col-md-12 pb-24">
          <xpo-prime-autocomplete
            [source]="source"
            [selectedObjectToDisplay]="selectedAutocompleteValues[componentOwnershipFields.PLATFORM_ENG_ID]"
            [formGroup]="formGroup"
            [formControlName]="componentOwnershipFields.PLATFORM_ENG_ID"
            [name]="componentOwnershipLabels.PLATFORM_ENG_NAME"
            [required]="false"
            [readonly]="true"
            [showClear]="true"
            [minLength]="2"
            [forceSelection]="true"
            placeholder="Search by lastName"
          >
          </xpo-prime-autocomplete>
        </div>
        <div class="col-xl-6 col-lg-12 col-md-12">
          <mat-form-field floatLabel="always">
            <mat-label>{{ componentOwnershipLabels.APPROVED_INTERFACE_LIST }}</mat-label>
            <input type="text" matInput [formControlName]="componentOwnershipFields.APPROVED_INTERFACE_LIST" />
          </mat-form-field>
        </div>
        <div class="col-xl-3 col-lg-6 col-md-12">
          <mat-form-field floatLabel="always">
            <mat-label>{{ componentOwnershipLabels.OWNED_TABLE_PREFIX_LIST }}</mat-label>
            <input type="text" matInput [formControlName]="componentOwnershipFields.OWNED_TABLE_PREFIX_LIST" />
          </mat-form-field>
        </div>

        <div class="col-xl-3 col-lg-6 col-md-12">
          <mat-form-field floatLabel="always">
            <mat-label>{{ componentOwnershipLabels.SUPPORT_TYPE }}</mat-label>
            <input type="text" matInput [formControlName]="componentOwnershipFields.SUPPORT_TYPE" />
          </mat-form-field>
        </div>
        <div class="col-xl-3 col-lg-6 col-md-12">
          <mat-slide-toggle [formControlName]="componentOwnershipFields.SOX_COMPLIANT_IND"
            >Enable {{ componentOwnershipLabels.SOX_COMPLIANT_IND }}</mat-slide-toggle
          >
        </div>
        <div class="col-xl-3 col-lg-6 col-md-12">
          <mat-slide-toggle [formControlName]="componentOwnershipFields.AUTH_SCOPE_IND"
            >Enable {{ componentOwnershipLabels.AUTH_SCOPE_IND }}</mat-slide-toggle
          >
        </div>
        <div class="col-xl-6 col-lg-12 col-md-12">
          <mat-form-field floatLabel="always">
            <mat-label>{{ componentOwnershipLabels.DESCRIPTION }}</mat-label>
            <textarea rows="4" matInput [formControlName]="componentOwnershipFields.DESCRIPTION"></textarea>
          </mat-form-field>
        </div>
        <div class="col-xl-6 col-lg-12 col-md-12">
          <mat-form-field floatLabel="always">
            <mat-label>{{ componentOwnershipLabels.NOTES }}</mat-label>
            <textarea rows="4" matInput [formControlName]="componentOwnershipFields.NOTES"></textarea>
          </mat-form-field>
        </div>
      </div>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button
      mat-flat-button
      [disabled]="!formGroup.valid || loading || (isBulkUpdate && !formGroup.dirty)"
      (click)="save()"
    >
      Save
    </button>
    <button mat-button color="primary" (click)="cancel()">Cancel</button>
  </mat-dialog-actions>
</div>
